export default {
  title: 'Imprint',
  subtitle: 'This appears in your online shop and storefront footers only once you save it.',
  card_title: 'Imprint',
  placeholder: 'Enter your imprint details',
  status: {
    saved: 'Saved',
    not_shown: 'Not shown in your shop or storefront yet',
    unsaved: 'Unsaved changes — your shop and storefront show the last saved version',
  },
  save: 'Save',
  retry: 'Try again',
  preview: {
    title: 'Footer preview (shop and storefront)',
    terms: 'Terms',
    privacy: 'Privacy',
    cookies: 'Cookies',
    imprint: 'Imprint',
  },
  toasts: {
    saved: 'Imprint saved',
    save_failed: 'Could not save the imprint. Please try again.',
    load_failed: 'Could not load the imprint. Please reload the page.',
  },
};
